import "./App.css";
import "./App.scss";
import { useState, lazy, Suspense, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "./Mycomponent/share/loader";
import RouterConfrigration from "./Navigation/routerConfigration";
import { fetchAndApplyWhiteLabelOffline } from "./Mycomponent/share/custom-hook/whiteLabelUtils";

const DeleteModalDialog = lazy(() =>
  import("./Mycomponent/share/components/dialog/DeleteModalDialog")
);
// const CrispChat = lazy(() => import("./ExtraScript/CrispChat"));
const GlobalSnackbar = lazy(() =>
  import("./Mycomponent/share/components/GlobalSnackbar")
);
const ConvertKitScript = lazy(() => import("./ExtraScript/ConvertKitScript"));
const PostHogInitializer = lazy(() =>
  import("./ExtraScript/PostHogInitializer")
);

function App() {
  const [defLoading, setDefLoading] = useState(true);
  const domain = window.location.hostname; // 💡 Not in `location`

  useEffect(() => {
    fetchAndApplyWhiteLabelOffline(domain);
  }, [domain]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDefLoading(false); // Simulate loading based on Redux store
    }, 1000);

    return () => {
      clearTimeout(timerId); // Clean up timeout on unmount
    };
  }, []);

  return (
    <>
      <div
        className={defLoading ? "loading-skeleton App" : "App"}
        style={{ overflow: "hidden" }}
      >
        {/* Lazy load non-critical scripts */}
        <Suspense fallback={null}>
          {/* <CrispChat /> */}
          <GlobalSnackbar />
          <DeleteModalDialog />
          <ConvertKitScript />
          <PostHogInitializer />
        </Suspense>
        <RouterConfrigration />
      </div>
      {defLoading ? <Loader /> : null}{" "}
    </>
  );
}

export default App;
